import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { facilityStayAction } from 'src/redux/actions/constant';
import facilityStayService from 'src/services/apiServices/facilityStayService';

const {
  REQUEST_GET_ALL_FACILITIES_STAY,
  SUCCESS_GET_ALL_FACILITIES_STAY,
  LOADER_GET_ALL_FACILITIES_STAY,
  FAILURE_GET_ALL_FACILITIES_STAY,
} = facilityStayAction;

function* getAllFacilitiesStay(action: any): SagaReturnType<any> {
  try {
    yield put({type:LOADER_GET_ALL_FACILITIES_STAY})
    const response = yield call(facilityStayService.getAllFacilityStay, action.uuid, action.params);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_ALL_FACILITIES_STAY, payload: response });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_ALL_FACILITIES_STAY, payload: error });
  }
}

function* getAllFacilitiesStaySaga() {
  yield takeEvery(REQUEST_GET_ALL_FACILITIES_STAY, getAllFacilitiesStay);
}

export default getAllFacilitiesStaySaga;
